import FailIcon from "../../assets/images/FailIcon.svg";
import * as React from "react";
import { Box, Button, Typography, Modal } from "@mui/material";
import "./style.css";
import { GlobalContext, GlobalContextType } from "../../context/GlobalContext";
import useTranslation from "../../hooks/translations";
import { AccessTime } from "@mui/icons-material";

interface PaymentFailedModalProps {
  transactionId: string;
  isOpen: boolean;
  onClose: any;
  returnUrl: string;
}

const COUNT_DOWN_TIME = 9;

const PaymentFailedModal: React.FC<PaymentFailedModalProps> = ({
  transactionId,
  isOpen,
  onClose,
  returnUrl,
}) => {
  const { errorRequest } = React.useContext<GlobalContextType>(GlobalContext);
  const { t } = useTranslation();
  const [countDownToRedirect, setCountDownToRedirect] =
    React.useState(COUNT_DOWN_TIME);

  const errorMessages: { [key: string]: string } = {
    "00020": t("mobileError"),
    "00004": t("paymentError"),
    "0001": t("request"),
    "0002": t("customer_cancelled_payment"),
    "0003": t("transaction_not_authorized"),
    "0004": t("payment_is_pending"),
    "0005": t("suspected_fraud"),
    "0006": t("merchant_void_payment"),
    "0007": t("merchant_partial_refund"),
    "0008": t("merchant_full_refund"),
    "0009": t("redirect"),
    "0010": t("need_more_info"),
    "0011": t("expired"),
  };

  const errorMessage =
    (errorRequest?.code && errorMessages[errorRequest.code]) ||
    t("generalError");

  const returnToMerchantPage = (url: string) => {
    window.location.replace(url);
  };

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCountDownToRedirect((prev: number) => prev - 1);
    }, 1000);
    if (countDownToRedirect <= 0) {
      clearInterval(interval);
      window.location.replace(returnUrl);
    }
    return () => clearInterval(interval);
  }, [countDownToRedirect, setCountDownToRedirect, returnUrl]);

  return (
    <Modal
      open={isOpen}
      onClose={(e, reason) => onClose(e, reason)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={"box"}>
        <Box className={"imageBox"}>
          <img src={FailIcon} alt="success" />
        </Box>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          className={"centerText"}
          data-testid="payment-failed"
          sx={{ fontSize: "20px", fontWeight: "600", marginBottom: 2 }}
        >
          {t("paymentFailed")}
        </Typography>
        <Typography
          variant="body1"
          component="p"
          gutterBottom
          sx={{ color: "#667085" }}
          className={"centerText"}
        >
          {errorMessage}
        </Typography>
        <Typography
          variant="body1"
          component="p"
          gutterBottom
          sx={{ color: "#667085", marginBottom: 1.5 }}
          className={"centerText"}
        >
          {t("noCharge")}
        </Typography>
        <Typography
          variant="body1"
          component="p"
          gutterBottom
          sx={{ color: "#667085", marginBottom: 1.5 }}
          className={"centerText"}
        >
          {t("redirectToMerchant")}
        </Typography>
        <Box
          sx={{
            alignItems: "center",
            textAlign: "center",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
          gap={0.5}
        >
          <AccessTime fontSize="small" color="primary" />
          <Typography sx={{ color: "#0AA5B7" }}>
            {" "}
            {`0:0${countDownToRedirect}`}
          </Typography>
        </Box>
        <Button
          variant="contained"
          onClick={() => returnToMerchantPage(returnUrl)}
          sx={{ color: "white", mt: 2, textTransform: "capitalize" }}
          className={"button"}
        >
          {t("return")}
        </Button>
      </Box>
    </Modal>
  );
};

export default PaymentFailedModal;
